import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "userRegisterView" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"16px"} }, "用户注册", -1)
const _hoisted_3 = { style: {"text-align":"center"} }

import { reactive, ref } from "vue";
import { UserControllerService } from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserRegisterView',
  setup(__props) {

const router = useRouter();
const loading = ref(false);

const form = reactive({
  userAccount: "",
  userPassword: "",
  checkPassword: "",
});

const rules = {
  userAccount: [
    { required: true, message: "账号不能为空" },
    { minLength: 4, message: "账号至少4位" },
  ],
  userPassword: [
    { required: true, message: "密码不能为空" },
    { minLength: 8, message: "密码至少8位" },
  ],
  checkPassword: [
    { required: true, message: "请确认密码" },
    {
      validator: (value: string, callback: (error?: string) => void) => {
        if (value !== form.userPassword) {
          callback("两次输入的密码不一致");
        } else {
          callback();
        }
      },
    },
  ],
};

const handleSubmit = async () => {
  loading.value = true;
  try {
    const res = await UserControllerService.userRegisterUsingPost(form);
    if (res.code === 0) {
      message.success("注册成功，请登录");
      router.push({ path: "/user/login" });
    } else {
      message.error("注册失败，" + res.message);
    }
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      style: {"max-width":"480px","margin":"0 auto"},
      "label-align": "left",
      "auto-label-width": "",
      model: form,
      rules: rules,
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "userAccount",
          label: "账号",
          "hide-label": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAccount) = $event)),
              placeholder: "请输入账号（至少4位）"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userPassword",
          label: "密码",
          "hide-label": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.userPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userPassword) = $event)),
              placeholder: "请输入密码（至少8位）"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "checkPassword",
          label: "确认密码",
          "hide-label": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.checkPassword) = $event)),
              placeholder: "请再次输入密码"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              long: "",
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 注册 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" 已有账号？ "),
          _createVNode(_component_a_link, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/user/login')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("立即登录")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})